module.exports = __webpack_public_path__ + "static/media/indeed.0b2fddeb.svg";